
export const PageHook = {
    Contact: "contact"
};